import { Popup } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

/**
 * We have to use these styles in conjunction with `height: 100%` on the popup's content
 * and `height: calc(100% - ${popupHeaderHeight}px)` on the container itself
 * to make the popup's content left side scrollable. To make it scrollable with dynamic
 * height container such kind of magic have to be done.
 */
export const StyledPopup = styled(Popup)`
    display: grid;
    grid-template-rows: 0 max-content 100%;
`;
